import React, { useEffect, useState } from 'react';
import ModalForm from '../Reusable/ModalForm';
import { SubmitButton } from '../../enums/GlobalEnums';
import { ModalForAddOrUpdateTravelOrder } from '../../enums/TravelOrderEnums';
import dayjs from 'dayjs';

const ModalForAddTravelOrder = ({
  handleAdd,
  handleClose,
  show,
  travelOrderReducer,
  municipalities,
}) => {
  const { error } = travelOrderReducer;

  const [maxReturnDateTime, setMaxReturnDateTime] = useState(null);

  const [initialValues] = useState({
    startDateTime: '',
    returnDateTime: '',
    startPointId: '',
    returnPointId: '',
    refueling: '',
    startingMileage: '',
    finalMileage: '',
  });

  const fields = [
    {
      name: 'startDateTime',
      label: 'Datum i vreme polaska',
      type: 'datetime',
      onChange: (value) => {
        if (!value) {
          setMaxReturnDateTime(null);
          return;
        }

        const start = dayjs(value);

        const maxReturn =
          start.hour() <= 4
            ? start.add(10, 'hour')
            : start.add(12, 'hour');

        setMaxReturnDateTime(maxReturn);
      },
    },
    {
      name: 'returnDateTime',
      label: 'Datum i vreme povratka',
      type: 'datetime',
      maxDateTime: maxReturnDateTime,
    },
    {
      name: 'startPointId',
      label: 'Mesto polaska',
      type: 'select',
      options: municipalities.map((m) => ({ value: m.id, label: m.name })),
    },
    {
      name: 'returnPointId',
      label: 'Mesto dolaska',
      type: 'select',
      options: municipalities.map((m) => ({ value: m.id, label: m.name })),
    },
    {
      name: 'refueling',
      label: 'Natočeno goriva',
      type: 'number',
    },
    {
      name: 'startingMileage',
      label: 'Početna kilometraža',
      type: 'number',
    },
    {
      name: 'finalMileage',
      label: 'Krajnja kilometraža',
      type: 'number',
    },
  ];

  const handleSubmit = (formData) => {

    const start = dayjs(formData.startDateTime);
    const end = dayjs(formData.returnDateTime);

    const maxReturn =
      start.hour() <= 4
        ? start.add(10, 'hour')
        : start.add(12, 'hour');

    if (end.isAfter(maxReturn)) {
      alert(
        `Povratak ne može biti nakon ${maxReturn.format(
          'DD.MM.YYYY HH:mm'
        )}`
      );
      return;
    }


    const payload = {
      refueling: Number(formData.refueling),
      returnDateTime: dayjs(formData.returnDateTime).format('DD.MM.YYYY HH:mm'),
      returnPointId: formData.returnPointId,
      startDateTime: dayjs(formData.startDateTime).format('DD.MM.YYYY HH:mm'),
      startPointId: formData.startPointId,
      startingMileage: Number(formData.startingMileage),
      finalMileage: Number(formData.finalMileage),
    };
    handleAdd(payload);
  };

  return (
    <ModalForm
      open={show}
      onClose={handleClose}
      title={ModalForAddOrUpdateTravelOrder.titleForAddTravelOrder}
      fields={fields}
      onSubmit={handleSubmit}
      initialValues={initialValues}
      error={error}
      submitLabel={SubmitButton.save}
    />
  );
};

export default ModalForAddTravelOrder;
